import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { adminApi, tokenStorage, setUnauthorizedHandler } from "@/api/adminClient";

const AdminAuthContext = createContext(null);

export const AdminAuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  const logout = useCallback(() => {
    tokenStorage.clear();
    setAdmin(null);
  }, []);

  useEffect(() => {
    setUnauthorizedHandler(() => {
      setAdmin(null);
    });
  }, []);

  const refresh = useCallback(async () => {
    const token = tokenStorage.get();
    if (!token) {
      setAdmin(null);
      setLoading(false);
      return;
    }
    try {
      const res = await adminApi.get("/admin/me");
      setAdmin(res.data);
    } catch {
      setAdmin(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = useCallback(async (email, password) => {
    const res = await adminApi.post("/admin/login", { email, password });
    tokenStorage.set(res.data.token);
    setAdmin(res.data.admin);
    return res.data.admin;
  }, []);

  return (
    <AdminAuthContext.Provider
      value={{ admin, loading, login, logout, refresh }}
    >
      {children}
    </AdminAuthContext.Provider>
  );
};

export const useAdminAuth = () => {
  const ctx = useContext(AdminAuthContext);
  if (!ctx) throw new Error("useAdminAuth must be used inside AdminAuthProvider");
  return ctx;
};
